import InvalidMaskParam from '../interfaces/InvalidMaskParam';
import UpdatePasswordError from '../interfaces/UpdatePasswordError';
import Messages from './Messages';


class InvalidMaskMessages {
  public static getMessage(
    error: string
  ): string {
    const errorObject: UpdatePasswordError = JSON.parse(error);
    const params: InvalidMaskParam[] = errorObject.PARAMS;

    const invalidMask = params.find((param) => param.INVALID_MASK === true);

    if (!invalidMask) {
      return Messages.PASSWORD_VALIDATION_DEFAULT;
    }

    const validationMessage = Messages.getMessage(invalidMask.MESSAGE);

    if (!validationMessage) {
      return Messages.PASSWORD_VALIDATION_DEFAULT;
    }

    const maskParams = invalidMask.PARAMS || {};

    const message = Object.keys(maskParams).reduce((accumulator, paramName) => {
      const paramValue = maskParams[paramName].toString();
      return accumulator.replace(`{{${paramName}}}`, paramValue);
    }, validationMessage);

    return message;
  }
}

export default InvalidMaskMessages;
